import { useState, useEffect } from "react";

import { InputMask } from "primereact/inputmask";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

import CardSeplag from "./../../../components/CardSeplag";
import TableSeplag from "../../../components/TableSeplag";
import RotuloSeplag from "../../../components/RotuloSeplag";
import ModalSeplag from "../../../components/ModalSeplag";

import Timeline from '../../../pages/Auditoria/components/Timeline';
import CustomizedContent from "./components/CustomizedContent";

import { buscarLogPorAmparoLegal } from '../../../service/Audit/AmparoLegal';
import { pesquisarLista } from '../../../service/ManterAmparoLegal';

// service
import { pesquisarAll as pesquisarAllAmparoLegal, remover as removerAmparoLegal, buscarPersonalizada as filtrarAmparoLegal } from "../../../service/ManterAmparoLegal"

import { pesquisarAll as pesquisarAllTipoAto } from "../../../service/TipoAto"

import { pesquisarAll as pesquisarAllEsferaGoverno } from "../../../service/EsferaGoverno";

import { pesquisarAll as pesquisarAllOrgao } from "../../../service/Orgao"

const formFiltro = {
  idenEsferaGoverno: null,
  numrAto: "",
  dataPublicacaoAto: null,
  idenTipoAto: null,
  descComplementoAmparo: "",
  orgao: {
    idenOrgao: null,
  },
};

const AmparoLegal = () => {

  // dados pagina
  const [dataManterAmparoLegal, setDataManterAmparoLegal] = useState([]);
  const [listaOrgao, setListaOrgao] = useState([]);
  const [listaTipoAto, setListaTipoAto] = useState([]);
  const [listaEsferaGoverno, setListaEsferaGoverno] = useState([]);
  const [data, setData] = useState(formFiltro);
  const [visible, setVisible] = useState(false);
  const [amparoLegalSelected, setAmparoLegalSelected] = useState();
  const [logs, setLogs] = useState([]);
  const [listaAmparo, setListaAmparo] = useState([]);

 
   useEffect(() => {
    pesquisarAllAmparoLegal().then((res) => {
      setListaAmparo(res.content);
    });

    pesquisarAllOrgao().then((res) => {
      setListaOrgao(res);
    });

    pesquisarAllTipoAto().then((res3) => {
      setListaTipoAto(res3);
    });

    pesquisarAllEsferaGoverno().then((res4) => {
      setListaEsferaGoverno(res4);
    });
  }, []);

  const onFiltrarAmparoLegal = async () => {
    let rowData = {
      idenEsferaGoverno: data.idenEsferaGoverno,
      numrAto: data.numrAto,
      dataPublicacaoAto: data.dataPublicacaoAto,
      idenTipoAto: data.idenTipoAto,
      orgao: {
        idenOrgao: data.orgao.idenOrgao,
      },
    };

    if (rowData) {
      await filtrarAmparoLegal(rowData).then((res) => {
        setListaAmparo(res.content);
      });
    } else {
        pesquisarLista().then((res) => {
        setListaAmparo(res.content);
      });
    }
  };

 const showModalLog = (rowData) => {
    setAmparoLegalSelected({ ...rowData });
    buscarLogPorAmparoLegal(rowData.idenAmparoLegal).then((res) => {
      setLogs(res.filter((element) => element.auditoriaDTO));
       setVisible(true);
    });
  };

  // campos da tabela
const camposTabela = [
    { titulo: "Descrição", nome: "descAmparoLegal" },
    { titulo: "Data início", nome: "dataInicioVigencia" },
    { titulo: "Data Publicação Ato", nome: "dataPublicacaoAto" },
    { titulo: "Data Término", nome: "dataTerminoVigencia" },
    // { titulo: "Número Ato",   nome: "numrAto"},
    // { titulo: "Ano",   nome: "numrAnoAto"},
  ];

  const botoesAcoes = (rowData) => {
    return <Button icon="pi pi-list" tooltip="log" tooltipOptions={{ position: "left" }} onClick={() => showModalLog(rowData)} />;
  };  
  
  return (
    <CardSeplag title="Amparo Legal">        
      <div className="p-grid p-col-12 p-md-12">
        <RotuloSeplag nome="Tipo do Ato:" cols="12 4">
          <Dropdown filter style={{ width: "100%" }} optionLabel="descTipoAto" optionValue="idenTipoAto" id="idenTipoAto" value={data?.idenTipoAto} showClear onChange={(e) => setData({ ...data, idenTipoAto: e.value })} options={listaTipoAto} placeholder="Selecione..." />
        </RotuloSeplag>
        <RotuloSeplag nome="Número do Ato:" cols="12 4">
          <InputText id="numrAto" style={{ width: "100%" }} name="numrAto" value={data.numrAto} onChange={(e) => setData({ ...data, numrAto: e.target.value })} />
        </RotuloSeplag>
        <RotuloSeplag nome="Data da Publicação:" cols="12 4">
          <InputMask mask="99/99/9999" style={{ width: "100%" }} placeholder="Data" value={data?.dataPublicacaoAto} onChange={(e) => setData({ ...data, dataPublicacaoAto: e.value })} />
        </RotuloSeplag>

        <RotuloSeplag nome="Orgão:" cols="12 4">
          <Dropdown filter style={{ width: "100%" }} optionLabel="descOrgao" optionValue="idenOrgao" id="idenOrgao" value={data?.orgao.idenOrgao} showClear onChange={(e) => setData({ ...data, orgao: { ...data.orgao, idenOrgao: e.value } })} options={listaOrgao} placeholder="Selecione..." />
        </RotuloSeplag>
        <RotuloSeplag nome="Complemento:" cols="12 4">
          <InputText value={data.descComplementoAmparo} onChange={(e) => setData({ ...data, descComplementoAmparo: e.target.value })} />
        </RotuloSeplag>
        <RotuloSeplag nome="Esfera:" cols="12 4">
          <Dropdown
            filter
            style={{ width: "100%" }}
            optionLabel="descEsferaGoverno"
            optionValue="idenEsferaGoverno"
            id="idenEsferaGoverno"
            value={data?.idenEsferaGoverno}
            showClear
            onChange={(e) => setData({ ...data, idenEsferaGoverno: e.value })}
            options={listaEsferaGoverno}
            placeholder="Selecione..."
          />
        </RotuloSeplag>

        <div className="p-col-12 p-md-3" style={{ marginTop: "10px" }}>
          <Button onClick={onFiltrarAmparoLegal} icon="pi pi-search" label="Pesquisar" className="p-col" />
        </div>
      </div>      
         
      <TableSeplag hasEventoAcao camposTabela={camposTabela} dados={listaAmparo}  botoesAcoes={botoesAcoes} />
        {visible && (
        <ModalSeplag
          type="NONE"
          titulo={`Log do Amparo Legal: ${amparoLegalSelected.descAmparoLegal}`}
          visible={visible}
          fechar={() => setVisible(false)}
          maximizable
        >
          <Timeline
            logs={logs}
            customizedContent={CustomizedContent}
          />

        </ModalSeplag>
      )}         
    </CardSeplag>
  );
};

export default AmparoLegal;
